import { render, staticRenderFns } from "./RecursiveCategoryAutoComplete.vue?vue&type=template&id=63c3d8bc"
import script from "./RecursiveCategoryAutoComplete.vue?vue&type=script&lang=js"
export * from "./RecursiveCategoryAutoComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports